import { render, staticRenderFns } from "./StatusProyekComponent.vue?vue&type=template&id=b6b1459e&scoped=true"
import script from "./StatusProyekComponent.vue?vue&type=script&lang=js"
export * from "./StatusProyekComponent.vue?vue&type=script&lang=js"
import style0 from "./StatusProyekComponent.vue?vue&type=style&index=0&id=b6b1459e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b1459e",
  null
  
)

export default component.exports